


















import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component({
  components: {}
})

export default class Keywords extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  clickLabel(item) {
    this.onClick(item)
  }

  clickCancel(ref) {
    this.$refs[ref][0].checked = false;
    this.onClick();
  }

  @Prop() items: any[];
  @Prop() onClick: Function;
}
